import { Videos } from '../_app/cuchillo/components/Videos';
import { Acordions } from '../_app/cuchillo/components/Acordions';
import { isTouch } from '../_app/cuchillo/core/Basics';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Page from '../_app/cuchillo/pages/Page';
import Preloader from '../layout/Preloader';
import Wrap from '../layout/Wrap';
import Keyboard from '../_app/cuchillo/core/Keyboard';
import Header from '../layout/Header';
import Curtain from '../layout/Curtain';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';

export default class NoScroll extends Page {
  constructor() {
    super();

    Videos.init();
    Acordions.init();

    document.body.classList.add('__noScroll');
  }

  //SHOW
  beforeShow() {
    super.beforeShow();

    Scroll.init(Scroll.AXIS_Y, { domResize: this.container, smooth: !isTouch, multiplicator: 1 });

    Keyboard.mountPage(this.id);
    Header.sendDown();

    if (this.isFirstTime) Header.selectPage(true);
  }

  show__effect(__call) {
    Curtain.hide();

    if (this.isFirstTime) {
      Wrap.show(() => {
        Preloader.hide(() => { this.afterShow() });
      });
    } else {
      Wrap.show(() => { this.afterShow() });
    }
  }

  afterShow() {
    super.afterShow();
    Scroll.show();

    if (this.isFirstTime) Header.show();
  }

  //HIDE
  beforeHide() {
    Curtain.show();
    Keyboard.unmountPage(this.id);
    super.beforeHide();
  }

  hide__effect() {
    Wrap.hide(() => { this.afterHide(); });
  }

  afterHide() {
    Header.selectPage();
    super.afterHide();

    document.body.classList.remove('__noScroll');
  }

  //RESIZE
  resize() {
    super.resize();
    Acordions.resize();
  }

  //LOOP
  loop() {
    if (this._isActive) {
      super.loop();
    }
  }
}

ControllerPage._addPage('no-scroll', NoScroll);